export default "__VITE_ASSET__ef6cfea1__"